import './StepperDrawerHeader.scss';

import { IconArrowLeft } from '@hulu-react-style-components/icons';
import React from 'react';

import Button from '../../../../../../common/Button';
import Tooltip from '../../../../../../common/Tooltip';
import bem from '../../../../../../utils/bem';

const [block, element] = bem('stepper-drawer-header');

export type StepperDrawerHeaderProps = {
  title: React.ReactNode;
  step: number;
  confirmButtonDisabled: boolean;
  onNext?: () => void;
  onCancel: () => void;
  onBack: () => void;
  confirmText?: string;
  loading?: boolean;
  tooltipText?: string;
  tooltipId?: string;
  hideCancel?: boolean;
};

const StepperDrawerHeader = ({
  title,
  step,
  confirmButtonDisabled,
  onNext,
  onCancel,
  onBack,
  confirmText = 'Next',
  tooltipText,
  tooltipId = 'stepper-drawer-next-button',
  loading,
  hideCancel = false,
}: StepperDrawerHeaderProps): React.JSX.Element => {
  return (
    <div className={block()}>
      {step !== 0 && (
        <div className={element('arrow')}>
          <IconArrowLeft data-testid="backIcon" onClick={onBack} />
        </div>
      )}
      <div className={element('title')}>{title}</div>
      <div className={element('buttons-container')}>
        {!hideCancel && (
          <Button size="medium" variant="outlined" className={element('close')} onClick={onCancel}>
            Cancel
          </Button>
        )}
        <Tooltip
          id={tooltipId}
          message={tooltipText ?? ''}
          disable={!confirmButtonDisabled || loading}
          delayHide={100}
          delayShow={200}
        >
          <Button
            size="medium"
            disabled={confirmButtonDisabled}
            className={element('next-step')}
            data-testid="next-button"
            onClick={onNext}
            loading={loading}
          >
            {confirmText}
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default StepperDrawerHeader;
